import { targetMatchPattern } from './targetMatchPattern.js';
export const getBadgeCount = (blocks = [], filter = {}) => blocks.filter(({ content = {} }) => targetMatchPattern(filter, content)).length;
//# sourceMappingURL=getBadgeCount.js.map